"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasGameObjectAtlas = void 0;
const BaseGameObjectAtlas_1 = require("./BaseGameObjectAtlas");
class CanvasGameObjectAtlas extends BaseGameObjectAtlas_1.BaseGameObjectAtlas {
    constructor(renderer) {
        super(2048, renderer);
    }
    removeTextureFromAtlas(id, rect, atlasIndex) {
    }
}
exports.CanvasGameObjectAtlas = CanvasGameObjectAtlas;
//# sourceMappingURL=module.js.map